/**
 * @description:人像参数
 * @return {*}
 */
const FACE = {
   // 获取抽验是否开启倒计时文本提示音
    ENABLE_STUDY_SAMPLE_TIP_AUDIO: "pc_study_validate_voice",
    // 人脸图片限制
    STUDENT_FACE_IMAGE_SIZE_LIMIT: "face_image_size_limit",   
}

/**
 * @description: 培训参数
 * @return {*}
 */
const TRAN = {

}

/**
 * 专项培训 - 培训类型
 */
export const PARAM_SPECIAL_TRAIN_SUB_TYPE = {
    SUB_TYPE: "train_subtype", // 专项计划培训类型（映射培训类别
    SUB_TYPE_FORM_RULE: "train_subtype_show_requirement", // 专项培训类型表单页面显示要求
};
export {FACE, TRAN};